/*                                                   */
otto.debug.assignNamespace(
  {
    /*                                                            */
    sendLog: (namespace, data) => window.AS.RUM.sendCustomRequest(namespace, data),
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
